import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";

export default class ArDeliveryMethodsService extends ApiService {
  namespace = "method";
  icon = "Package";
  name = "method";
  favicon = "Stamp";
  window = 290;
  Width = 690;
  DOMAIN = DOMAIN.DELIVERY_METHOD;
  singular = this.terminology.method.singular;
  plural = this.terminology.method.plural;
  vowel = this.terminology.method.vowel;
  action = "action";
  singular = this.terminology.method.singular;
  plural = this.terminology.method.plural;
  vowel = this.terminology.method.vowel;
  constructor() {
    super("ar-delivery-methods");
  }
}
